import coursesExpressUtils from "@/utils/courses-express";

export const coursesExpressProductListProps = () => ({
  canDelete: {
    type: Boolean,
    required: false,
    default: false
  },
  items: {
    type: Array,
    required: true
  },
  sections: {
    type: Array,
    required: true
  },
  indisponibles: {
    type: Array,
    required: false,
    default() {
      return [];
    }
  },
  cartContext: {
    type: String,
    required: false,
    default: ""
  }
})

export const coursesExpressProductListEmits = () => ([
  "delete"
])

export const useCoursesExpressProductList = (props, context) => {
  const selectedProducts = ref([]);

  const itemsBySections = computed(() => {
    return coursesExpressUtils.listeBySections(props.items, props.sections);
  })
  const sectionIndisponible = computed(() => {
    return coursesExpressUtils.mapIndisponibles(props.indisponibles);
  })
  const totalItems = computed(() => {
    return props.items.length + props.indisponibles.length;
  })

  const toggleSelectProduct = (value, product) => {
    const isInArray = selectedProducts.value.some(selectedProduct => selectedProduct.id === product.id);
    if (value && !isInArray) {
      selectedProducts.value.push(product);
    } else if (isInArray) {
      selectedProducts.value = selectedProducts.value.filter(selectedProduct => selectedProduct.id !== product.id);
    }
  }
  const isSelected = (id) => {
    return selectedProducts.value.some(selectedProduct => selectedProduct.id === id);
  }
  const selectAll = () => {
    selectedProducts.value = [...props.items, ...sectionIndisponible.value];
  }
  const unselectAll = () => {
    selectedProducts.value = [];
  }
  const deleteItem = (item) => {
    context.emit("delete", [item]);
  }

  return {
    itemsBySections,
    sectionIndisponible,
    totalItems,
    toggleSelectProduct,
    isSelected,
    selectAll,
    unselectAll,
    deleteItem,
    selectedProducts
  }
}